import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ElConfigProvider } from "element-plus";
import zhCn from 'element-plus/es/locale/lang/zh-cn'; // 生产环境
// import zhCn from 'element-plus/lib/locale/lang/zh-cn' // 测试环境
import { onMounted, ref, watch } from "vue";
import { checkSession, getClientId } from "@/store/cache";
import { isChrome, isMobile } from "@/utils/libs";
import { showMessageInfo } from "@/utils/dialog";
import { useSharedStore } from "@/store/sharedata";
import { getUserToken } from "@/store/session";
import SvgSprite from '@/components/SvgSprite.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const debounce = (fn, delay) => {
      let timer;
      return (...args) => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn(...args);
        }, delay);
      };
    };
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 200);
        super(callback);
      }
    };
    const store = useSharedStore();
    onMounted(() => {
      // 获取系统参数
      // getSystemInfo().then((res) => {
      //   const link = document.createElement("link");
      //   link.rel = "shortcut icon";
      //   link.href = res.data.logo;
      //   document.head.appendChild(link);
      // });
      if (!isChrome() && !isMobile()) {
        showMessageInfo("建议使用 Chrome 浏览器以获得最佳体验。");
      }
      checkSession().then(() => {
        store.setIsLogin(true);
      }).catch(() => {});
      // 设置主题
      document.documentElement.setAttribute("data-theme", store.theme);
    });
    watch(() => store.isLogin, val => {
      if (val) {
        // connect();
      }
    });
    const handler = ref(0);
    // 初始化 websocket 连接
    const connect = () => {
      let host = process.env.VUE_APP_WS_HOST;
      if (host === "") {
        if (location.protocol === "https:") {
          host = "wss://" + location.host;
        } else {
          host = "ws://" + location.host;
        }
      }
      const clientId = getClientId();
      const _socket = new WebSocket(host + `/api/ws?client_id=${clientId}`, ["token", getUserToken()]);
      _socket.addEventListener("open", () => {
        console.log("WebSocket 已连接");
        handler.value = setInterval(() => {
          if (_socket.readyState === WebSocket.OPEN) {
            _socket.send(JSON.stringify({
              type: "ping"
            }));
          }
        }, 5000);
      });
      _socket.addEventListener("close", () => {
        clearInterval(handler.value);
        connect();
      });
      store.setSocket(_socket);
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view), _createVNode(SvgSprite)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});